import React from 'react'

const EmployeeFiles = () => {
  return (
    <div>EmployeeFiles</div>
  )
}

export default EmployeeFiles